
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g8h0sXuU0urSJR8AdXt15oC48J41cVHGBkJsQ9e8kbcUMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index1G4xYWdCXevvBT9G3Biu5wLpq4MhsSqWq_CJIgQrXjcMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchkb5YX2K1FnvV28ugqh9i4U1taVQSXh8H5FiU6STSuWsMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1TgZLgdq08cx2jW8JCBl8j8_7b3SDGpQ3XFziCTEMg4Meta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93wGTD0njXiro_eA3CowWN0UMbRsXhIxCPH0n2Uy13dfAMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index1lZZ4cby1EBT4qWQY4gM8VtpmZB4hVpOVH9gk7PGzFcMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_938CQAT6TWZMkBtcpIZ6lutU0bLvEJ2JkL_mOvIW3XYIIMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexpsYQKWYynuzAZeb0U7iYYE5Lh2wUue0u4JmXFwTqdFYMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93J4t_45dkc0gaYohy5pea2PNeERi5bgKES3Lsu_y_WWdYgMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexbUFVdBD6avoKO3o9_i9lCyR11tBuWk3Ll0nsGGZnPlAMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexu_sGSkNWT1G2JVqjj204MObim5gN0bJCAU8uhh8784EMeta } from "/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index1lZZ4cby1EBT4qWQY4gM8VtpmZB4hVpOVH9gk7PGzFcMeta || {},
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpsYQKWYynuzAZeb0U7iYYE5Lh2wUue0u4JmXFwTqdFYMeta || {},
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexbUFVdBD6avoKO3o9_i9lCyR11tBuWk3Ll0nsGGZnPlAMeta || {},
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexu_sGSkNWT1G2JVqjj204MObim5gN0bJCAU8uhh8784EMeta || {},
    component: () => import("/codebuild/output/src106740290/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]